import Swiper from 'swiper';
import '@fancyapps/fancybox';

$(document).ready(function () {
    try {
        var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        })
        var galleryTop = new Swiper('.gallery-top', {
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: galleryThumbs,
            }
        })
    } catch (err) {
        console.debug("Keine Bilder in Gallerie. Überspringe...");
    }
});
